import React, { useContext, useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { AuthContext } from "../auth/context/AuthContext";
import { USER_ROLES } from "./types/UserRole";
import { Loading } from "./Shared/Loading/Loading";

const ProtectedRoute = ({ allowedUsers, children }) => {
  const { Auth, User } = useContext(AuthContext);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  if (Auth) {
    const userRoles = Array.isArray(User.role) ? User.role : [User.role];
    const isUserAllowed = userRoles.some(role => role === USER_ROLES.ADMIN || role === USER_ROLES.ENOVATE);

    if (isUserAllowed) {
      return children ? children : <Outlet />;
    } else {
      alert("No tienes permiso para acceder a esta vista.");
      return <Navigate to="/login" replace />;
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};

export default ProtectedRoute;